// @ts-nocheck
import { Link as RouterLink, useLocation, useParams, useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
// material
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
// material
import { Grid, Button, Container, Stack, Typography, Rating, Image, Avatar, TextField } from '@mui/material';
// components
import Page from '../components/Page';
import Iconify from '../components/Iconify';
import { DetailsCard, SpacePostsSort, SpacePostsSearch } from '../sections/@dashboard/parkings';
import { useSelector } from 'react-redux';
import { red, grey } from '@mui/material/colors';
import { useAppSelector } from '../store/hooks';
import { compareAsc, format } from 'date-fns';
import { useFindParkingSpaceLocationByIdMutation } from '../store/api/parkingsApi';

// ----------------------------------------------------------------------

const SORT_OPTIONS = [
  { value: 'latest', label: 'Latest' },
  { value: 'popular', label: 'Popular' },
  { value: 'oldest', label: 'Oldest' },
];

// ----------------------------------------------------------------------

export default function ParkingDetails() {
  const params = useLocation();
  const parkingSpaceInState = useAppSelector((state) => state.parkings.data);
  const [searchParams, setSearchParams] = useSearchParams(params.search);
  const [parkingSpace, setParkingSpace] = useState(null);
  const [parkingfeedback, setParkingFeedback] = useState(null);
  const parkingId = parseInt(searchParams.get('id'));
  const token: any = JSON.parse(localStorage.getItem('login') || '{}') || null;
  const [findParkingSpaceLocationById, findByIdParkingResponse] = useFindParkingSpaceLocationByIdMutation();
  const [imageList, setImageList] = useState([]);

  useEffect(() => {
    findParkingSpaceLocationById({ id: parkingId, token: token.token });
  }, []);

  useEffect(() => {
    if (findByIdParkingResponse.isSuccess) {
      setImageList(() => findByIdParkingResponse.data.imageList);
    }
  }, [findByIdParkingResponse.isSuccess]);

  useEffect(() => {
    if (parkingSpaceInState) {
      const parkingSpace = parkingSpaceInState.find((parking) => parking.id === parkingId);
      setParkingSpace(parkingSpace);
    }
  }, [parkingSpaceInState]);

  useEffect(() => {
    if (findByIdResponse.isSuccess) {
      setParkingFeedback(findByIdResponse.data);
    }
  }, [findByIdResponse.isSuccess]);

  return (
    <Page title="Parking Space">
      {parkingSpace ? (
        <Box sx={{ boxShadow: '0px 0px 12px #0000002f', padding: '30px', borderRadius: '10px' }}>
          <Box style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
            <Box>
              <Typography variant="h4" component="div" gutterBottom>
                {parkingSpace.name}
              </Typography>
              <Typography variant="h6" component="div" color={grey[600]} fontWeight={'normal'} gutterBottom>
                {parkingSpace.address}
              </Typography>
              <Rating name="simple-controlled" value={parkingfeedback ? parkingfeedback.AverageRating : 0} readOnly />
              <Typography variant="subtitle2" color={grey[600]} gutterBottom component="div">
                {parkingfeedback ? parkingfeedback.TotalReview : 0} Reviews
              </Typography>
            </Box>
            {imageList === null ? (
              <img src={`https://dummyimage.com/600x280/${grey[500]}/fff`} />
            ) : (
              <div>
                {imageList?.length > 0 && (
                  <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                    {imageList?.map((image, index) => (
                      <Box
                        key={index}
                        sx={{
                          width: '600px',
                          height: '280px',
                          margin: '10px',
                          border: '1px solid #ccc',
                          borderRadius: '5px',
                          position: 'relative',
                        }}
                      >
                        <img
                          src={image}
                          alt={image}
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                          }}
                        />
                      </Box>
                    ))}
                  </Box>
                )}
              </div>
            )}
          </Box>
          <Box style={{ marginTop: '30px' }}>
            <Typography variant="h5" component="div" gutterBottom>
              Customer Reviews
            </Typography>
            {parkingfeedback &&
              parkingfeedback.data.length > 0 &&
              parkingfeedback.data.map((value) => (
                <Box style={{ backgroundColor: grey[200], borderRadius: '0px', padding: '20px' }}>
                  <Box style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                    <Avatar
                      alt="Remy Sharp"
                      src="https://dummyimage.com/100/red/fff"
                      sx={{ width: 56, height: 56, marginRight: '10px' }}
                    />
                    <Box>
                      <Typography variant="subtitle1" style={{ margin: 0, padding: 0 }} component="div" gutterBottom>
                        {value.customerName}
                      </Typography>
                      <Typography variant="body1" component="div" gutterBottom>
                        {format(new Date(value.date), 'MM/dd/yyyy')}
                      </Typography>
                    </Box>
                  </Box>
                  <Rating name="simple-controlled" value={value.rating} readOnly />
                  <Typography variant="body1" component="div" gutterBottom>
                    {value.comments}
                  </Typography>
                  <TextField
                    fullWidth
                    type="text"
                    name="reply"
                    label="Reply, Vendor can only reply once to the customer."
                  />
                </Box>
              ))}
          </Box>
        </Box>
      ) : (
        <Box sx={{ padding: '30px', borderRadius: '10px' }}>
          <Typography variant="h4" component="div" gutterBottom>
            Parking Space not found
          </Typography>
        </Box>
      )}
    </Page>
  );
}
